import { Grid, GridItem, Text } from "@chakra-ui/react";
import React from "react";
import CustomInput from "../../../components/UI/CustomInput";

export default function ExposureAndCreditLimit({
  isCreditLimit,
  payload,
  setPayload,
  clientData,
  errors = {},
  validateRequiredField,
}) {
  return (
    <Grid className="simple-modal-grid" templateColumns="140px 1fr">
      <GridItem className="simple-modal-label">
        <Text>{isCreditLimit ? "Old Credit" : "Old Limit"}</Text>
      </GridItem>
      <GridItem>
        <CustomInput
          value={Number(
            !isCreditLimit
              ? payload?.user?.exposureLimit ?? 0
              : payload?.user?.creditReference ?? 0
          ).toFixed(2)}
          isReadOnly
        />
      </GridItem>
      <GridItem className="simple-modal-label">
        <Text>{isCreditLimit ? "New Credit" : "New Limit"}</Text>
      </GridItem>
      <GridItem>
        <CustomInput
          required
          error={errors.newLimit}
          onFocus={() =>
            validateRequiredField(
              "newLimit",
              `The ${isCreditLimit ? "New Credit" : "New Limit"} field is required`
            )
          }
          onChange={(e) => {
            setPayload({
              ...payload,
              newLimit: e.target.value,
            });
          }}
        />
      </GridItem>
      <GridItem className="simple-modal-label">
        <Text>Transaction Password</Text>
      </GridItem>
      <GridItem>
        <CustomInput
          required
          minLength={6}
          error={errors.transactionPassword}
          onFocus={() => validateRequiredField("transactionPassword", "The Transaction Code field is required")}
          type="password"
          name="client-limit-transaction-code"
          autoComplete="new-password"
          onChange={(e) => {
            setPayload({
              ...payload,
              transactionPassword: e.target.value,
            });
          }}
        />
      </GridItem>
    </Grid>
  );
}
